module.exports = __webpack_public_path__ + "static/media/pipelineLG.951d573e.png";